import React, { useState } from 'react';
import {
  ProductPrice, ProductName, ProductImage,
} from 'anf-core-react';

const OutfitHoverDetails = ({ product, brand }) => {
  const {
    name, prices,
  } = product;

  const { originalPrice, discountPrice, description } = prices?.list || {};

  return (
    <>
      <ProductName brand={brand}>{name}</ProductName>
      <ProductPrice
        brand={brand}
        description={description}
        discountPrice={discountPrice ?? null}
        originalPrice={originalPrice}
        variant="discount"
      />
    </>
  );
};

const OutfitImage = ({
  product, onQuickview, isDisabled, brand,
}) => {
  const {
    productId, kicId, name, imageUrl,
  } = product;
  const [isHovered, setIsHovered] = useState(false);
  const isInteractive = !isDisabled;

  const handleMouseEnter = () => isInteractive && setIsHovered(true);
  const handleMouseLeave = () => isInteractive && setIsHovered(false);
  const handleClick = () => isInteractive && onQuickview(product);
  const handleKeyDown = (e) => {
    if (isInteractive && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onQuickview(product);
    }
  };

  return (
    <div
      data-testid={`outfit-item-${productId}`}
      id={kicId}
      className={`pdp-outfitting-item${isDisabled ? ' pdp-outfitting-item--disabled' : ''}`}
      role="button"
      tabIndex={isDisabled ? -1 : 0}
      aria-disabled={isDisabled}
      aria-label={isDisabled
        ? `${name} (currently viewing)`
        : `View ${name}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
    >
      <ProductImage
        src={imageUrl}
        alt={name}
        loading="lazy"
        decoding="async"
      />
      {isHovered && isInteractive && (
        <div className="pdp-outfitting-hover-details">
          <OutfitHoverDetails product={product} brand={brand} />
        </div>
      )}
    </div>
  );
};

export default OutfitImage;
